import { render, staticRenderFns } from "./CommonEmail.vue?vue&type=template&id=10a8d8b6&scoped=true&"
import script from "./CommonEmail.vue?vue&type=script&lang=ts&"
export * from "./CommonEmail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a8d8b6",
  null
  
)

export default component.exports